<template>
	<v-dialog v-model="dialog" persistent max-width="400" style="z-index: 100000;">
		<v-card>
			<v-card-title class="text-h5">
				{{ $t("ConfirmationModal.areYouSure") }}
			</v-card-title>
			<v-card-text>
				{{ text }}
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="red darken-1" text @click="$emit('closeDialog', false)">
					{{ $t("ConfirmationModal.cancel") }}
				</v-btn>
				<v-btn color="green darken-1" text @click="$emit('closeDialog', data)">
					{{ $t("ConfirmationModal.yes") }}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	name: "ConfirmationModal",
	props: ["dialog", "text", "data"],
};
</script>
